import { useEffect } from 'react';

import { Outlet, useParams } from 'react-router-dom';

import { GbmwRedirectLoader } from '@/components/gbmw-redirect-loader';
import { env } from '@/env';
import { isMobileOrTabletBrowser } from '@/utils/device';

// Work-order email links land here unauthenticated; a phone/tablet on a build
// that knows the GBMW URL is routed straight to the work order on GBMW. Runs
// before ProtectedRoute so a user who has never logged into Gearbelt Web isn't
// diverted into its separate login/workspace-resolution flow before reaching
// GBMW.
function WorkOrderGbmwRedirectRoute() {
  const { id } = useParams<{ workspaceId: string; id: string }>();

  const gbmwUrl = isMobileOrTabletBrowser() && env.VITE_GBMW_URL && id ? `${env.VITE_GBMW_URL}/work-orders/${id}` : undefined;

  useEffect(() => {
    if (gbmwUrl) {
      window.location.replace(gbmwUrl);
    }
  }, [gbmwUrl]);

  if (gbmwUrl) {
    return <GbmwRedirectLoader />;
  }

  return <Outlet />;
}

export default WorkOrderGbmwRedirectRoute;
